@if (isLoading) {
  <div class="loading-indicator">
    <mat-progress-spinner
      mode="indeterminate"
      color="accent"
    ></mat-progress-spinner>
  </div>
}
@if (!isLoading && result && !error) {
  <div class="team_container">
    <div class="team_panel_holder">
      <div class="team_top">
        {{ result.total }}
      </div>
      <div class="team_top"></div>
      <div class="team_bottom">CREATED</div>
    </div>
    <div class="team_panel_holder team_center">
      <div class="team_top">
        {{ result.shares }}
      </div>
      <div class="team_bottom">SHARES</div>
    </div>
    <div class="team_panel_holder">
      <div class="team_top">
        {{ result.views }}
      </div>
      <div class="team_bottom">VIEWS</div>
    </div>
  </div>
}
@if (!isLoading && !error && !result) {
  <div>
    <p>Results will be available after more data has been collected.</p>
  </div>
}
@if (error) {
  <p class="chartErrorText">{{ error }}</p>
}
